<template>
  <div class="Risk" style="background-color: white">
    <div style="height: 58px;background-color: white;border-bottom: 2px solid #E1E1E1;">
      <el-col :span="19" :offset="5">
        <div style="float: left">
          <img  src="./images/logo.png"  />
        </div>
        <div style="margin-left: 200px">
          <span style="font-size: 28px;color: #2B78D9;margin-left: -110px;font-weight: bolder">通辽市能碳管理中心</span>
        </div>
      </el-col>
    </div>
    <div style="background: #FFFFFF;">
      <div style="width: 1200px;margin: auto;height: 15px;margin-top: 10px">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 14px;">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
<!--          <el-breadcrumb-item :to="{ path: '/'+ pathName,query:{titleName:title,activeName:activeName}}">{{title}}</el-breadcrumb-item>-->
          <el-breadcrumb-item >{{resultData.post.spec.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="width: 1200px;border: 2px solid #EEEEEE;margin: auto;margin-top: 10px">
        <div style="font-size: 28px;font-weight: bold;width: 700px;text-align: center;margin: auto;height: 74px;">
          <sapn>
            <!--            习近平主持召开新时代推动东北全面振兴座谈会强调:牢牢把握东北的重要使命 奋力谱写东北全面振兴新篇章-->
            {{resultData.post.spec.title}}
          </sapn>
        </div>
        <div style="width: 500px;margin: auto;height: 20px;margin-top: 10px">
          <!--          jsonData-->
          <!--          {{resultData.createBy}}-->
<!--          <span style="float: left">作者:{{resultData.source}}</span>-->
<!--          <span style="margin-left: 100px">来源:{{resultData.source}}</span>-->
          <!--          {{resultData.createDate}}-->
          <!--          {{jsonData.createDate}}-->
          <!--          {{resultData.createDate.slice(0,4)}}-{{resultData.createDate.slice(4,6)}}-{{resultData.createDate.slice(6,8)}}-->
<!--          <sapn style="float: right">发布时间：{{resultData.publishDate.slice(0,4)}}-{{resultData.publishDate.slice(4,6)}}-{{resultData.publishDate.slice(6,8)}}</sapn>-->
        </div>
        <div style="height: 3px;width: 1113px;border-top: 2px solid #E7E7E7;margin: auto;margin-top: 10px"></div>
        <div style="width: 1100px;margin: auto;min-height: 700px">
          <div style="text-indent: 2em;margin-top: 20px">
            <span v-html="resultDescribe"></span>
<!--            {{resultData.resultDescribe}}-->
          </div>
          <div style="text-indent: 2em;margin-top: 20px;text-align: center">
<!--            style="height: 500px; width: 500px"-->
<!--            <img :src="resultData.post.spec.cover" alt="" >-->
          </div>
        </div>
      </div>
<!--      <div style="width: 1200px;margin: auto;height: 50px;margin-top: 10px">-->
<!--        <button @click="backToTable" style="color: #2B78D9;background-color: white;border: 2px solid #2B78D9;font-size: 18px;cursor: pointer;">-->
<!--          返回列表-->
<!--        </button>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
import data from '@/assets/test.json';
import qs from 'qs' 
import axios from "axios";
import * as Setting from "@/setting";
const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
const config = {
  headers: {
    'Authorization': 'Basic aGFsb2FkbWluOkNhUmJvbkAyNC4y', // 设置认证令牌
    // 'Authorization': 'Basic c3ViaW5naGU6MTIzNDU2', // 设置认证令牌
    // 'Authorization': 'Basic YWRtaW46Rmd3XzIwMjQh', // 设置认证令牌
    'Content-Type': 'application/json' // 设置内容类型为JSON
  }
};
export default {
  data() {
    return {
      // resultData:{},
      // resultData:this.$route.query.dataDetail,
      jsonData: data,
      title:this.$route.query.activeName=='QYJS'?"前沿技术":this.$route.query.activeName=='YXAL'?"优秀案例":"解决方案",
      activeName: this.$route.query.activeName,
      resultData:qs.parse(this.$route.query.dataDetail),
      demo:null,
      // resultIndex: this.$route.query.resultIndex,
      activeId: 1,
      pathName:'tableDetailPromotion',
      resultDescribe:'',
      tabPosition: "left",
      tabList: [
        { id: 1, job: "分类系统" },
        { id: 2, job: "查询系统" },
        { id: 3, job: "小贴士" },
      ],
    };
  },
  created() {
    // let that =this;
    // if(that.activeName=='QYJS'){
    //   that.getData();
    // }else if(that.activeName=='YXAL'){
    //   that.getData();
    // }else if(that.activeName=='JJFA'){
    //   that.getData();
    // }
    // this.getData();
    this.getDetail()
    this.$emit('header',false);
  },
  methods: {
    getDetail(){
      let that =this;
      axios.get(Setting.getHalo()+'/v1alpha1/posts/'+qs.parse(this.$route.query.dataDetail).post.metadata.name+'/head-content',
          config ).then(response => {
            that.resultDescribe=response.data.content
      });
    },
    getData(){

      let that =this;
      // that.resultData=that.$route.query.dataDetail;
      axios.get(cacheBuster('/door/'+qs.parse(this.$route.query.dataDetail).imageName)) // 替换为你的图片服务器路径
          .then(res => {
            let it =res.request.responseURL;
            that.demo=it;
            // if(that.promotionList.length<4){
            //   that.promotionList.push(item);
            // }
            // this.images.push(item);
            // console.log('Received responseURL:', response.request.responseURL);
          })

      // gonggao  listxts
      // axios.get("/door/carbonPromotion.json", {params: {}}).then(function(response) {
      //   if(that.$route.query.titleName=='通知公告'){
      //     that.resultData=response.data[that.resultIndex];
      //   }
      // })
      // .catch(function(error) {
      //   console.log(error);
      // });
    },
    backToTable(){
      console.log(this.$route.query.resultData);
      console.log(this.resultData);
      this.$router.push("/wordDetail");
      // title
      this.$router.push({
        path: this.pathName,
        query: {titleName:this.title,activeName:this.activeName}
        // query: {titleName:title,activeName:activeName},
      })
    },
  },

};
</script>
<style lang="less" scoped>
.Risk {
  background: #f2f2f2;
  //width: 1200px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.container {
  width: 1200px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 0 auto;
  margin-top: 20px;
}
.box {
  margin-top: 15px;
  width: 100%;
  height: 12px;
}
/deep/ .el-breadcrumb {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  line-height: 12px;
  float: left;
}
.dangqian {
  float: left;
}
/deep/.el-breadcrumb__inner {
  font-weight: 400 !important;
}
.red {
  color: #dd2126;
}

.isActive {
  background: #fce9ea;
}
.left {
  width: 180px;
  height: 267px;
  background-color: white;
}
.smallBox {
  width: 180px;
  height: 52px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 52px;
  text-align: center;
}
.top {
  margin-top: 24px;
  width: 180px;
  height: 52px;
  line-height: 52px;
  display: flex;
  justify-content: flex-start;
  background-color: #dd2126;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.yi {
  margin-left: 10px;
  font-size: 16px;
  line-height: 50px;
  color: white;
}
.right {
  margin-left: 20px;
  width: 1000px;
  min-height: 712px;
  background-color: white;
  padding: 41px 40px;
  box-sizing: border-box;
}
i {
  margin-left: 10px;
  width: 18px;
  height: 18px;
  color: white;
}
.blue {
  color: #2B78D9;
}
</style>
